import * as React from 'react';
import { IActionButtonProps } from './types';

const ActionButton = ({
  children,
  disabled = false,
  type = 'primary',
  className,
  style,
  onClick,
}: IActionButtonProps) => {
  return (
    <button
      className={`actionButton actionButton--${type} ${className ?? ''}`}
      style={style}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default ActionButton;



// WEBPACK FOOTER //
// ./src/modules/ActionButton/ActionButton.tsx